import {
  addExpenseAccount,
  getChartExpense,
  getStatesData,
  getUserAccountList,
  handleKeyDown,
  makePaymentApi,
  uploadFiles,
  venderDropdownApi,
} from "_services";
import {
  CityDropdownForTrip,
  CommonCanvas,
  CommonDatePicker,
  CommonInput,
  CommonModal,
  CommonSwitch,
  CustomSelect,
} from "components";
import { constant } from "constants/constant";
import { Images } from "constants";
import { UserContext } from "context";
import { errorSchema, utils } from "helper";
import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { IoCloseCircle } from "react-icons/io5";
import StorageService from "utils/StorageServices";
import { getBranchDropdownListData, getBranchListApi } from "_services/dropdownServices/dropdownService";
import AddExpenseCategoryModal from "modals/AddExpenseCategoryModal";
import { AddEditVendors } from "modals";

const AddExpensesModal = (props) => {

  let { isEditDetails, isOpen } = props;

  const arryOptions = [
    { label: "Goods", value: "Goods" },
    { label: "Service", value: "Service" },
  ];

  const initial = {
    type: 8,
    sub_type: null,
    date: new Date(),
    is_gst: 0,
    is_invoice: false,
    tax_type: 0,
    total_amount: "",
    account_category: "",
    account_sub_category: "",
    account_id: "",
    vendor_type: 4,
    vendor_id: {},
    invoice_number: "",
    invoice_date: new Date(),
    place_of_supply: {},
    lr_id: "",
    trip_id: "",
    vehicle_id: "",
    branch_id: {},
    company_id: StorageService.getCompanyId(),
    is_approval: 0,
    expenses: [],
    file: [],
    // description: "",
  };

  const expenseInit = {
    category: '',
    tax: '',
    hsn_code: "",
    description: "",
    type: "",
    amount: "",
  };

  const { masterData, states, generalExpensesIndex, setGeneralExpensesIndex } = useContext(UserContext);
  const [form, setForm] = useState(initial);
  const [expenseTypeList, setExpenseTypeList] = useState([]);
  const [expenseList, setExpenseList] = useState([]);
  const [expenseArray, setExpenseArray] = useState([expenseInit]);
  const [formError, setFormError] = useState("");
  const [gstTaxList, setGstTaxList] = useState([]);
  const [accountLoading, setAccountLoading] = useState(false);
  const [accountList, setAccountList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [accountType, setAccountType] = useState(null);
  const [isLoadding, setIsLoadding] = useState(false);
  const [isLoaddingforsave, setIsLoaddingForSave] = useState(false);
  const [aprroveStatus, setAprroveStatus] = useState();
  const [venderList, setVenderList] = useState([]);
  const [statesList, setStatesList] = useState([]);

  const [isOpenVenderModal, setIsOpenVenderModal] = useState(false);
  const [venderSelection, setVenderSelection] = useState(false);

  const [dropdownBranchList, setDropdownBranchList] = useState([]);
  const [isSupply, setIsSupply] = useState({});

  const [gstTypeAmount, setGstTypeAmount] = useState([]);

  const [addNewExpense, setAddNewExpense] = useState(false);

  useEffect(() => {
    getMasterData();
    getExpenseHandler();
    // getDropdownDataBranchList();
  }, [masterData]);

  useEffect(() => {
    // getVenderHandler();
  }, [isOpenVenderModal])

  const calculateTotalAmount = () => {
    const exTotal = expenseArray?.reduce((total, item) => {
      const amount = parseFloat(item?.amount) || 0;
      return total + amount;
    }, 0);

    return exTotal.toFixed(2);
  };

  useEffect(() => {
    if (
      form?.account_sub_category != "15" &&
      form?.account_category &&
      expenseTypeList.length
    ) {
      if (form?.account_id == "") {
        getAccountListHandler();
      }
    }
  }, [
    form?.account_sub_category,
    form?.account_category,
    expenseTypeList,
    form?.account_id,
    isEditDetails
  ]);

  // useEffect(() => {

  // if (form?.is_gst && form?.account_category) {
  //   handleOnChange("place_of_supply", { name: "" });
  // } else {
  //   if (form?.account_category) {
  //     handleOnChange("place_of_supply", null);
  //   }
  // }

  // let firstArray = [...expenseTypeList]
  // let newArrays = firstArray?.filter((el) => el?.value != 26)
  // if (form?.is_gst) {
  //   setExpenseTypeList(newArrays);
  // } else {
  //   let array = newArrays?.filter((el) => el?.value != 15 )
  //   setExpenseTypeList(array);
  // }

  // }, [form?.is_gst]);

  useEffect(() => {
    if (accountType) {
      setForm((s) => ({ ...s, account_id: '' }))
    }
  }, [accountType]);

  const handleOnChange = async (name, value) => {
    const stateObj = {
      ...form,
      [name]: value,
    };
    if (name === 'branch_id') {
      stateObj["vendor_id"] = {};
    }
    setForm(stateObj);

    if (!!formError) {
      const validationResult = await utils.checkFormError(
        { ...stateObj },
        errorSchema.addExpenseAccountSchema
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const getMasterData = async () => {
    try {
      const detailsAccount = masterData?.account_category?.sub_category?.map(
        (item) => {
          return {
            label: item?.name,
            value: item?.id,
            category_id: masterData?.account_category?.id,
          };
        }
      );

      const gstTaxList = masterData?.gst_percentage_list?.map((item) => {
        return {
          ...item,
          label: item?.name,
          value: item?.id,
        };
      });

      if (detailsAccount && gstTaxList) {
        if (!isEditDetails?.isEdit) {
          setForm({
            ...form,
            type: masterData?.general_expense?.id,
            sub_type: null,
            account_category: detailsAccount[0]?.category_id,
            account_sub_category: detailsAccount[0]?.value,
          });
          setAccountType(detailsAccount[0]?.value);
        }

        let newArrays = detailsAccount?.filter((el) => el?.value != 26)
        setExpenseTypeList(newArrays);
        setGstTaxList(gstTaxList);
      }

      // }
    } catch { }
  };

  const getExpenseHandler = async () => {
    try {
      const res = await getChartExpense({
        company_id: StorageService.getCompanyId(),
        category_id: 5,
        sub_category_id: 1,
      });

      if (res?.responseCode === 200) {
        const { category_id, sub_category_id } = res?.data;
        const details = res?.data?.categories?.map((item) => {
          return {
            label: item?.name,
            value: item?._id,
          };
        });

        const updatedList = expenseArray.map((item) => ({
          ...item,
          category_id: category_id,
          sub_category_id: sub_category_id,
        }));
        if (!isEditDetails?.isEdit) {
          setExpenseArray(updatedList);
        }
        setExpenseList(details?.reverse());
      } else {
      }
    } catch (error) {
    }
  };

  const getVenderHandler = async () => {
    try {
      const res = await venderDropdownApi({
        company_id: StorageService.getCompanyId(),
        offset: 1,
        limit: 2000,
        search: "",
      });

      if (res?.responseCode === 200) {
        const details = res?.data?.vendor_list?.map((item) => {
          return {
            label: item?.name,
            value: item?._id,
            gst_state: item?.gst_state,
          };
        });

        setVenderList(details);
      } else {
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    if (venderSelection) {
      let obj = venderSelection?.value ? venderSelection : venderList[0];
      handleOnChange("vendor_id", obj);
      setIsSupply(obj);
    }
  }, [venderSelection, venderList])

  const getAccountListHandler = async () => {
    setAccountLoading(true);
    try {
      const res = await getUserAccountList({
        company_id: StorageService?.getCompanyId(),
        category_id: parseInt(form?.account_category),
        sub_category_id: parseInt(form?.account_sub_category),
        firm_id: form?.branch_id?.firm_id?._id || StorageService?.getFirmId()
      });

      if (res?.responseCode === 200) {
        setAccountLoading(false);
        const details = res?.data?.account_list?.map((item) => {
          return {
            label: item?.name,
            value: item?._id,
          };
        });

        setAccountList(details);
        handleOnChange("account_id", isEditDetails?.payment_mode?.account?._id ? isEditDetails?.payment_mode?.account?._id : (details[0]?.value ? details[0]?.value : ""));

        // if (isEditDetails?.isEdit && isEditDetails?.payment_mode?.account?._id) {
        //   handleOnChange("account_id", isEditDetails?.payment_mode?.account?._id);
        // } else {
        //   handleOnChange("account_id", details[0]?.value ? details[0]?.value : "");
        // }
      } else {
        setAccountLoading(false);
      }
    } catch (error) {
      setAccountLoading(false);
    }
  };

  const addExpenseInput = (e) => {
    setExpenseArray((preState) => {
      return [...preState, expenseInit];
    });
  };

  const removeExpenseInput = (index) => {
    const newExpense = [...expenseArray];
    newExpense.splice(index, 1);
    setExpenseArray(newExpense);
  };

  const formatToTwoDecimal = (value) => {
    if (value === 0) return "";
    return value % 1 === 0 ? value.toString() : parseFloat(value.toFixed(2));
  };

  const handleExpenseChange = async (value, index, name) => {
    const list = [...expenseArray];
    list[index][name] = value;
    setExpenseArray(list);

    let arrayData = list?.map((el) => ({
      ...el,
      category: el?.category?.value ? el?.category?.value : '',
    }))

    if (!utils.isObjectKeyEmpty(formError)) {
      const validationResult = await utils.dynamicCheckFormError(
        { ...form, expenseArray: arrayData },
        errorSchema.addExpenseAccountSchema
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const getStateValue = (value) => {
    const stateList = statesList?.map((i) => {
      return {
        ...i,
        label: i?.name,
        value: i?.name,
      };
    });
    const stateValue = stateList?.find((i) => i?.value === value);
    return stateValue;
  };

  const handleFileChange = async (e) => {
    if (
      e?.target?.files[0]?.type === "image/gif" ||
      e?.target?.files[0]?.type === "image/jpeg" ||
      e?.target?.files[0]?.type === "image/png"
    ) {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("file", e?.target?.files[0]);
        const res = await uploadFiles(formData);
        if (res?.responseCode === 200) {
          var fileArray = [];
          fileArray.push(...form?.file, {
            filename: res?.data?.filename,
            path: res?.data?.path,
          });
          handleOnChange("file", fileArray);
          setLoading(false);
          toast.success("Document added ");
        }
      } catch (error) {
        setLoading(false);
      }
    } else {
      toast.error("Invalid file, choose jpeg/png images");
    }
  };

  const documentRemove = (index) => {
    const newFromIput = [...form?.file];
    newFromIput.splice(index, 1);
    setForm({ ...form, file: newFromIput });
    toast.success("Document Deleted");
  };

  const onHandleSubmit = async (approve) => {

    let arrayData = expenseArray?.map((el) => ({
      ...el,
      category: el?.category?.value ? el?.category?.value : '',
    }))

    const validationResult = await utils.dynamicCheckFormError(
      { ...form, expenseArray: arrayData },
      errorSchema.addExpenseAccountSchema
    );

    const formattedExpenseArray = expenseArray.map((expense) => ({
      ...expense,
      amount: parseFloat(parseFloat(expense.amount || 0).toFixed(2)),
      category: { _id: expense?.category?.value ? expense?.category?.value : '', name: expense?.category?.label ? expense?.category?.label : '' }
    }));

    formattedExpenseArray?.forEach(obj => {
      if (!form?.is_gst) {
        delete obj.tax;
      }
      delete obj.category_id;
      delete obj.sub_category_id;
      delete obj.gst_amount;
    });

    const payload = {
      ...form,
      is_approval: approve,
      amount: +parseFloat(parseFloat(form.amount || 0).toFixed(2)),
      expenses: formattedExpenseArray,
      total_amount: +calculateTotalAmount(),
      place_of_supply: form?.place_of_supply?._id ? form.place_of_supply : {},
      branch_id: form?.branch_id?.value ? form?.branch_id?.value : '',
      vendor_id: form?.vendor_id?.value ? form?.vendor_id?.value : '',
    };
    delete payload.amount;

    if (validationResult == true) {
      if (approve == 0) {
        setIsLoaddingForSave(true);
      } else {
        setIsLoadding(true);
      }
      try {
        const res = await addExpenseAccount(payload);
        if (res?.responseCode == 200) {
          setIsLoadding(false);
          setIsLoaddingForSave(false);
          props?.callBackFreight();
          props?.closeModal();
          toast.success(res?.responseMessage)
        } else {
          setIsLoadding(false);
          setIsLoaddingForSave(false);
          // toast.error(res?.responseMessage)
        }
      } catch (error) {
        setIsLoaddingForSave(false);
        setIsLoadding(false);
        toast.error(error?.message)
      }
    } else {
      setFormError(validationResult);
    }
  };

  const SendFor = () => {
    onHandleSubmit(1);
    setAprroveStatus(1);
  };

  const addFreight = () => {
    onHandleSubmit(0);
    setAprroveStatus(0);
  };

  const updateGeneralExpense = async () => {
    setIsLoadding(true);
    try {
      const payload = {
        company_id: form?.company_id,
        date: new Date(form?.date),
        account_category: form?.account_category
          ? parseInt(form?.account_category)
          : "",
        account_sub_category: form?.account_sub_category
          ? parseInt(form?.account_sub_category)
          : "",
        account_id: form?.account_id ? form?.account_id : "",
        voucher_id: isEditDetails?._id,
        vendor_id: isEditDetails?.vendor_detail?._id ? isEditDetails?.vendor_detail?._id : '',
        vendor_type: isEditDetails?.vendor_type,
        old_account_id: form?.old_account_id
      };
      const res = await makePaymentApi(payload)
      if (res?.responseCode == 200) {
        setIsLoadding(false);
        setIsLoaddingForSave(false);
        props?.callBackFreight();
        props?.closeModal();
        toast.success(res?.responseMessage)
      } else {
        setIsLoadding(false);
        setIsLoaddingForSave(false);
        toast.error(res?.responseMessage)
      }
    } catch (error) {
      setIsLoaddingForSave(false);
      setIsLoadding(false);
      toast.error(error?.message)
    }
  };

  const propsExpenses = {
    ...props,
    isLoadding: isLoadding,
    disabled: aprroveStatus == 0 ? isLoaddingforsave : isLoadding,
    isLoaddingforsave: isLoaddingforsave,
    modalMainClass: 'mdOffcanvas',
    modalTitle: "General Expenses",
    sendApprovalButtonTitle: isLoadding ? 'Loading...' : (isEditDetails?.isEdit ? "Update & Save" : "Send for Approval"),
    showUpdateButton: true,
    onSubmit: (isEditDetails?.isEdit ? updateGeneralExpense : addFreight),
    submitTitle: isEditDetails?.isEdit ? "Complete Payment" : "Add General Expense",
    footerPart: isEditDetails?.isEdit ? false : true,
    sendFor: isLoadding ? 'Loading...' : (isEditDetails?.isEdit ? updateGeneralExpense : SendFor),
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength)
    }
  }

  const fetchBranch = async (search, page, limit) => {
    const res = await getBranchListApi({
      company_id: StorageService.getCompanyId(),
      firm_id: StorageService.getFirmId(),
      offset: page,
      limit,
      search,
    });

    if (res?.responseCode === 200) {
      setLoading(false);
      const list = await res?.data?.branch_list?.map((i) => ({
        ...i,
        label: i?.branch,
        value: i?._id
      }));

      if (!form?.branch_id?.value) {
        if (list?.length > 0 && list?.length == 1) {
          setForm((s) => ({ ...s, branch_id: list[0] }))
        }
      }

      return {
        items: list,
        total: res?.data?.total_record,
      };
    } else {
      setLoading(false);
    }
  };

  const fetchVender = async (search, page, limit) => {
    const res = await venderDropdownApi({
      company_id: StorageService.getCompanyId(),
      firm_id: form?.branch_id?.firm_id?._id || StorageService.getFirmId(),
      offset: page,
      limit,
      search,
    });

    if (res?.responseCode === 200) {
      setLoading(false);
      const list = await res?.data?.vendor_list?.map((i) => ({
        ...i,
        label: i?.name,
        value: i?._id,
        gst_state: i?.gst_state,
      }));

      return {
        items: list,
        total: res?.data?.total_record,
      };
    } else {
      setLoading(false);
    }
  };

  const getStatesByApi = async () => {
    try {
      let data = {
        countryCode: "IN",
        stateCode: ""
      }
      let response = await getStatesData(data);
      if (response?.responseCode === 200) {
        const optionsState = response?.data?.map((d) => {
          return {
            ...d,
            label: d?.name,
            value: d?.name
          };
        });

        StorageService.setStates(JSON.stringify([...optionsState]))
        setStatesList(optionsState);
      } else {
        if (response) {
          toast.error(response?.responseMessage)
        }

      }
    } catch (error) {
      toast.error("An unexpected error occurred. Please try again.")
    }
  }

  useEffect(() => {
    if (statesList?.length > 0 && !isEditDetails?.isEdit) {
      let object = statesList?.find((el) => (el?.name === isSupply?.gst_state?.label && el?.value === isSupply?.gst_state?.value));
      let newObj = (object?.name && object?._id) ? { ...object, label: object?.name ? object?.name : '', value: object?.name ? object?.name : '' } : null
      setForm((s) => ({
        ...s,
        place_of_supply: newObj?.label ? newObj : {}
      }))
    }
  }, [isSupply, isEditDetails, statesList])

  const sumAmount = () => {
    const exTotal = gstTypeAmount?.reduce((total, item) => {
      const amount = parseFloat(item?.gst * 2) || 0;
      return total + amount;
    }, 0);

    return exTotal.toFixed(2);
  };

  let commonAmountFunction = (tax, amount) => {
    return (amount * (tax / 2)) / 100;
  }

  useEffect(() => {
    if (!isEditDetails?.isEdit) {
      let newArray = expenseArray?.map((el) => {
        return {
          ...el,
          gst: commonAmountFunction(el?.tax, el?.amount),
        }
      })

      setGstTypeAmount(newArray);
    }
  }, [expenseArray, isEditDetails])

  const handleTableIndexAction = (name, index) => {
    if (name === "category") {
      setAddNewExpense(true);
      setGeneralExpensesIndex(index);
    }
  };

  const callBackApi = (data) => {

    let object = { label: data?.category?.name, value: data?.category?._id }
    handleExpenseChange(object, generalExpensesIndex, "category");
    setGeneralExpensesIndex(null);

    getExpenseHandler();
    setAddNewExpense(false);
  };

  let generalExpenseCategoryModal = {
    isOpen: addNewExpense,
    closeModal: (e) => setAddNewExpense(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: 'Expense Category',
    submitTitle: 'Add Expense Category',
    footerPart: true,
    label: 'Expenses Category',
    placeholder: 'Expenses Category',
    callBackApi: callBackApi,
    titleName: "Add Expense Category",
  };

  useEffect(() => {
    if (isEditDetails?.isEdit) {
      let customArray = isEditDetails?.categories?.map((el) => ({
        ...el,
        category: { label: el?.category?.name, value: el?.category?._id }
      }))
      setExpenseArray(customArray);

      setForm((s) => ({
        ...s,
        type: 8,
        sub_type: null,
        date: new Date(isEditDetails?.date),
        is_gst: isEditDetails?.is_gst,
        is_invoice: isEditDetails?.is_invoice,
        tax_type: isEditDetails?.tax_type,
        total_amount: isEditDetails?.total_amount,
        account_category: isEditDetails?.payment_mode?.account_category,
        account_sub_category: isEditDetails?.payment_mode?.account_sub_category,
        account_id: isEditDetails?.payment_mode?.account?._id,
        old_account_id: isEditDetails?.payment_mode?.account_sub_category != 15 ? isEditDetails?.payment_mode?.account?._id : '',
        vendor_type: isEditDetails?.vendor_type,
        vendor_id: isEditDetails?.vendor_detail?._id,
        invoice_number: isEditDetails?.invoice_number,
        invoice_date: new Date(isEditDetails?.invoice_date),
        place_of_supply: { ...isEditDetails?.place_of_supply, label: isEditDetails?.place_of_supply?.name, value: isEditDetails?.place_of_supply?.name }, // isEditDetails?.place_of_supply,
        lr_id: '', // isEditDetails?.lr
        trip_id: '', // isEditDetails?.trip
        vehicle_id: '', //isEditDetails?.vehicle
        branch_id: { label: isEditDetails?.branch?.branch, value: isEditDetails?.branch?._id },
        company_id: StorageService.getCompanyId(),
        is_approval: isEditDetails?.is_approval,
        expenses: customArray,
        file: isEditDetails?.file,
      }))

      let newArray = customArray?.map((el) => {
        return {
          ...el,
          gst: commonAmountFunction(el?.tax, el?.amount),
        }
      })
      setGstTypeAmount(newArray);
      setIsSupply(isEditDetails?.vendor_detail);
      setAccountType(isEditDetails?.payment_mode?.account_sub_category);
    }
  }, [isEditDetails])

  useEffect(() => {
    if (!isEditDetails?.isEdit) {
      if (!form?.is_invoice) {
        setForm((s) => ({ ...s, vendor_id: {}, account_id: '', account_sub_category: 2 }))
      }
    }
  }, [form?.is_invoice, isEditDetails])

  useEffect(() => {
    // if (dropdownBranchList?.length > 0 && dropdownBranchList?.length == 1 && isOpen) {
    //   setForm((s) => ({ ...s, branch_id: dropdownBranchList[0] }))
    // }
    fetchBranch();
    getStatesByApi();
  }, []) // dropdownBranchList, isOpen

  console.log('formError', formError)

  return (
    <>
      {/* <CommonModal {...propsExpenses}> */}
      <CommonCanvas {...propsExpenses}>
        <div className="offcanvas-body bg-white">
          <div className="__addExp_body">
            <div className="flxInr">
              <div className="halfDiv ps-3">
                {/* <CustomSelect
                  label="Select Branch"
                  placeholder="Select Branch"
                  options={dropdownBranchList}
                  value={form?.branch_id}
                  onSelect={(data) =>
                    handleOnChange("branch_id", data)
                  }
                  error={formError?.branch_id}
                  focus={!!formError?.branch_id}
                  errorShow={true}
                  disabled={isEditDetails?.isEdit ? true : false}
                /> */}
                <CityDropdownForTrip
                  label={"Branch"}
                  placeholder="Select Branch"
                  fetchData={fetchBranch}
                  pageSize={20}
                  onChange={(data) => {
                    handleOnChange("branch_id", data);

                  }}
                  selectedItem={form?.branch_id}
                  error={!!formError['branch_id.label']}
                  errorMessage={formError['branch_id.label']}
                  disabled={isEditDetails?.isEdit ? true : false}
                // isClearOption={form?.branch_id?.value ? true : false}
                // isClearHandleChange={() => {
                //   handleOnChange("branch_id", {}); // label: 'Assign Driver', value: ''
                // }}

                />
              </div>

              <div className="halfDiv pe-3">
                <CommonDatePicker
                  name="date"
                  label="Expense Date"
                  placeholderText="Expense Date"
                  startDate={form?.date}
                  setStartDate={(data) => {
                    handleOnChange("date", data);
                  }}
                  maxDate={new Date()}
                  error={formError?.date}
                  focus={!!formError?.date}
                  errorShow={true}
                  disabled={isEditDetails?.isEdit ? true : false}
                />
              </div>

              <div className="singleDiv _pMode_exbx px-3">
                <CommonSwitch
                  id="is_invoice"
                  name="is_invoice"
                  label="Add Invoice Details"
                  value={form?.is_invoice}
                  checked={form?.is_invoice}
                  onChange={({ target: { name, checked } }) => {
                    handleOnChange(name, checked ? true : false);
                  }}
                  disabled={form?.is_gst || isEditDetails?.isEdit}
                />
              </div>

              {form.is_invoice ?
                <>
                  <div className="halfDiv ps-3">
                    {/* <CustomSelect
                      label="Select Vendor"
                      options={venderList}
                      onSelect={(data) => {
                        handleOnChange("vendor_id", data?.value);
                        setIsSupply(data);
                      }}
                      placeholder="Select Vendor"
                      error={formError["vendor_id"]}
                      value={venderList?.find((i) => i.value == form?.vendor_id)}
                      isAddButton={true}
                      addButtonAction={(e) => setIsOpenVenderModal(true)}
                      errorShow={true}
                      disabled={isEditDetails?.isEdit ? true : false}
                    /> */}

                    <CityDropdownForTrip
                      label={"Vendor"}
                      placeholder="Select Vendor"
                      fetchData={fetchVender}
                      pageSize={20}
                      onChange={(data) => {
                        handleOnChange("vendor_id", data);
                        setIsSupply(data);
                      }}
                      addButtonAction={(e) => setIsOpenVenderModal(true)}
                      isAddButton={true}
                      selectedItem={form?.vendor_id}
                      error={!!formError['vendor_id.label']}
                      errorMessage={formError['vendor_id.label']}
                      disabled={isEditDetails?.isEdit ? true : false}
                      isClearOption={form?.vendor_id?.value ? true : false}
                      isClearHandleChange={() => {
                        handleOnChange("vendor_id", {}); // label: 'Assign Driver', value: ''
                      }}
                    />

                  </div>

                  <div className="halfDiv pe-3">
                    <CustomSelect
                      label="Place of Supply"
                      options={statesList}
                      onSelect={(data) => {
                        handleOnChange("place_of_supply", data);
                      }}
                      placeholder="Place of Supply"
                      value={form?.place_of_supply} // {getStateValue(form?.place_of_supply?.name)}
                      error={formError["place_of_supply.label"]}
                      errorShow={true}
                      disabled={isEditDetails?.isEdit ? true : false}
                    />
                  </div>

                  <div className="halfDiv ps-3">
                    <CommonInput
                      type="text"
                      label="Invoice Number"
                      placeholder="Invoice Number"
                      name="invoice_number"
                      maxLength={15}
                      value={form?.invoice_number}
                      onChange={({ target: { name, value } }) => {
                        handleOnChange(name, value);
                      }}
                      focus={!!formError?.invoice_number}
                      error={formError.invoice_number}

                      errorShow={true}
                      disabled={isEditDetails?.isEdit ? true : false}
                    />
                  </div>

                  <div className="halfDiv pe-3">
                    <CommonDatePicker
                      name="invoice_date"
                      label="Invoice Date"
                      placeholderText="Invoice Date"
                      startDate={form?.invoice_date}
                      setStartDate={(data) => {
                        handleOnChange("invoice_date", data);
                      }}
                      error={formError?.invoice_date}
                      focus={!!formError?.invoice_date}
                      errorShow={true}
                      disabled={isEditDetails?.isEdit ? true : false}
                    />
                  </div>
                </> : <></>}

              {form?.is_invoice ? <div className="singleDiv ">
                <div className="__gstToggle_bx">
                  <CommonSwitch
                    id="Exp_with_GST"
                    name="is_gst"
                    label="Expense with GST"
                    value={form?.is_gst}
                    checked={form?.is_gst}
                    onChange={({ target: { name, checked } }) => {
                      handleOnChange(name, checked ? 1 : 0);
                      if (checked) {
                        setForm((s) => ({ ...s, is_invoice: true, tax_type: 1 }))
                      } else {
                        setForm((s) => ({ ...s, tax_type: 0 }))
                      }
                    }}
                    disabled={isEditDetails?.isEdit ? true : false}
                  />
                </div>
              </div> : <></>}

              {form.is_gst ? <div className='d-flex gap-2 px-3'>
                <span> Amount </span>
                {
                  constant.Tax_type_amount?.map((el, ind) => {
                    return (
                      <React.Fragment key={ind}>
                        <div className='_dualCheckr_bx'>
                          <input
                            className="form-check-input"
                            id={+ind + "tax_type" + el?.value}
                            type="radio"
                            name="tax_type"
                            checked={form.tax_type === el?.value}
                            value={form.tax_type ? form.tax_type : ""}
                            onChange={({ target: { name, value } }) =>
                              handleOnChange(name, +el?.value)
                            }
                            disabled={isEditDetails?.isEdit ? true : false}
                          />
                          <label htmlFor={+ind + "tax_type" + el.value} className="form-check-label" >
                            {el.label}
                          </label>
                        </div>
                      </React.Fragment>
                    )
                  })
                }
              </div> : <></>}

              <div className="singleDiv ">
                <div className="_catGry_tableBx _withGst_catGry">
                  {form.is_gst ? (
                    <div className="__catrTb_row __catrTb_head">
                      <div className="__cat_childs">
                        <h5>Expense Category</h5>
                      </div>
                      <div className="__cat_childs">
                        <h5>Tax</h5>
                      </div>
                      <div className="__cat_childs">
                        <h5>Amount</h5>
                      </div>
                    </div>
                  ) : (
                    <div className="__catrTb_row __catrTb_head">
                      <div className="__cat_childs">
                        <h5>Expense Category</h5>
                      </div>
                      <div className="__cat_childs">
                        <h5>Amount</h5>
                      </div>
                    </div>
                  )}

                  {expenseArray?.map((exp, index) => {
                    return (
                      <React.Fragment key={index}>
                        {form?.is_gst ? (
                          <div className="__catrTb_row __catrTb_body">
                            <div className="__cat_childs">
                              <div>
                                <CustomSelect
                                  name="category"
                                  options={expenseList}
                                  onSelect={(data) => {
                                    handleExpenseChange(
                                      data,
                                      index,
                                      "category"
                                    );
                                  }}
                                  placeholder="Expense Category"
                                  error={
                                    formError[
                                    `expenseArray[${index}].category`
                                    ]
                                  }
                                  focus={
                                    !!formError[
                                    `expenseArray[${index}].category`
                                    ]
                                  }
                                  value={expenseArray[index].category}
                                  isAddButton={true}
                                  addButtonAction={(e) =>
                                    handleTableIndexAction("category", index)
                                  }
                                  errorShow={true}
                                  disabled={isEditDetails?.isEdit ? true : false}
                                />
                              </div>
                              <div className="mt-1">
                                <CommonInput
                                  type="text"
                                  placeholder="Item Description"
                                  name="description"
                                  value={exp?.description}
                                  onChange={({ target: { name, value } }) => {
                                    handleExpenseChange(
                                      value,
                                      index,
                                      "description"
                                    );
                                  }}
                                  focus={
                                    !!formError[
                                    `expenseArray[${index}].description`
                                    ]
                                  }
                                  error={
                                    formError[
                                    `expenseArray[${index}].description`
                                    ]
                                  }
                                  errorShow={true}
                                  disabled={isEditDetails?.isEdit ? true : false}
                                />
                              </div>
                            </div>

                            <div className="__cat_childs">
                              <div>
                                <CustomSelect
                                  name="tax"
                                  options={gstTaxList}
                                  onSelect={(data) => {
                                    handleExpenseChange(
                                      data?.value,
                                      index,
                                      "tax"
                                    );
                                  }}
                                  placeholder="Tax"
                                  focus={
                                    !!formError[
                                    `expenseArray[${index}].tax`
                                    ]
                                  }
                                  error={
                                    formError[
                                    `expenseArray[${index}].tax`
                                    ]
                                  }
                                  value={gstTaxList?.find(
                                    (i) => i.value == exp?.tax
                                  )}
                                  errorShow={true}
                                  disabled={isEditDetails?.isEdit ? true : false}
                                />
                              </div>
                              <div className="mt-1">
                                <CustomSelect
                                  options={arryOptions}
                                  placeholder="Type"
                                  onSelect={(data) => {
                                    handleExpenseChange(
                                      data?.value,
                                      index,
                                      "type"
                                    );
                                  }}
                                  focus={
                                    !!formError[
                                    `expenseArray[${index}].type`
                                    ]
                                  }
                                  error={
                                    formError[
                                    `expenseArray[${index}].type`
                                    ]
                                  }
                                  value={arryOptions?.find(
                                    (i) => i.value == exp?.type
                                  )}
                                  errorShow={true}
                                  disabled={isEditDetails?.isEdit ? true : false}
                                />
                              </div>
                            </div>

                            <div className="__cat_childs">
                              <div>
                                <CommonInput
                                  type="text"
                                  placeholder="Amount (₹)"
                                  name="amount"
                                  maxLength="10"
                                  onInput={maxLengthCheck}
                                  value={exp?.amount}
                                  // onChange={({ target: { name, value } }) => {
                                  //   handleExpenseChange(value, index, "amount");
                                  // }}
                                  onChange={({ target: { name, value } }) => {
                                    // if (/^\d*$/.test(value)) {
                                    if (/^\d*(\.\d{0,2})?$/.test(value)) {
                                      handleExpenseChange(value, index, "amount");
                                    }
                                  }}
                                  focus={
                                    !!formError[`expenseArray[${index}].amount`]
                                  }
                                  error={
                                    formError[`expenseArray[${index}].amount`]
                                  }

                                  errorShow={true}
                                  disabled={isEditDetails?.isEdit ? true : false}
                                />
                              </div>
                              <div className="mt-1">
                                <CommonInput
                                  type="text"
                                  placeholder="HSN Code"
                                  name="hsn_code"
                                  value={exp?.hsn_code}
                                  onChange={({ target: { name, value } }) => {
                                    if (/^\d*$/.test(value)) {
                                      handleExpenseChange(value, index, "hsn_code");
                                    }
                                  }}
                                  focus={
                                    !!formError[`expenseArray[${index}].hsn_code`]
                                  }
                                  error={
                                    formError[`expenseArray[${index}].hsn_code`]
                                  }

                                  errorShow={true}
                                  maxLength={6}
                                  disabled={isEditDetails?.isEdit ? true : false}
                                />
                              </div>
                            </div>

                            {expenseArray.length > 1 && (
                              <div className="mt-1">
                                {!isEditDetails?.isEdit ? <img
                                  className="_delExp"
                                  src={Images.DELETEICON.default}
                                  alt=""
                                  onClick={() => removeExpenseInput(index)}
                                /> : <></>}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="__catrTb_row __catrTb_body">
                            <div className="__cat_childs">
                              <div className="mt-1">
                                <CustomSelect
                                  name="category"
                                  options={expenseList}
                                  onSelect={(data) => {
                                    handleExpenseChange(
                                      data,
                                      index,
                                      "category"
                                    );
                                  }}
                                  placeholder="Expense Category"
                                  error={
                                    formError[
                                    `expenseArray[${index}].category`
                                    ]
                                  }
                                  focus={
                                    !!formError[
                                    `expenseArray[${index}].category`
                                    ]
                                  }
                                  value={expenseArray[index].category}
                                  isAddButton={true}
                                  addButtonAction={(e) =>
                                    handleTableIndexAction("category", index)
                                  }
                                  errorShow={true}
                                  disabled={isEditDetails?.isEdit ? true : false}
                                />
                              </div>
                            </div>

                            <div className="mt-1">
                              <CommonInput
                                type="text"
                                placeholder="Item Description"
                                name="description"
                                value={exp?.description}
                                onChange={({ target: { name, value } }) => {
                                  handleExpenseChange(
                                    value,
                                    index,
                                    "description"
                                  );
                                }}
                                focus={
                                  !!formError[
                                  `expenseArray[${index}].description`
                                  ]
                                }
                                error={
                                  formError[
                                  `expenseArray[${index}].description`
                                  ]
                                }
                                errorShow={true}
                                disabled={isEditDetails?.isEdit ? true : false}
                              />
                            </div>

                            <div className="__cat_childs">
                              <div className="mt-1">
                                <CommonInput
                                  type="text"
                                  placeholder="Amount (₹)"
                                  name="amount"
                                  maxLength="10"
                                  onInput={maxLengthCheck}
                                  value={exp?.amount}
                                  onChange={({ target: { name, value } }) => {
                                    // if (/^\d*$/.test(value)) {
                                    if (/^\d*(\.\d{0,2})?$/.test(value)) {
                                      handleExpenseChange(value, index, "amount");
                                    }
                                  }}
                                  focus={
                                    !!formError[`expenseArray[${index}].amount`]
                                  }
                                  error={formError[`expenseArray[${index}].amount`]}

                                  errorShow={true}
                                  disabled={isEditDetails?.isEdit ? true : false}
                                />
                              </div>
                            </div>

                            {expenseArray.length > 1 && (
                              <div className="mt-2">
                                {!isEditDetails?.isEdit ? <img
                                  className="_delExp"
                                  src={Images.DELETEICON.default}
                                  alt=""
                                  onClick={() => removeExpenseInput(index)}
                                /> : <></>}
                              </div>
                            )}
                          </div>
                        )}
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
              <div className="singleDiv ">
                <div className=" totalExp_bal pt-2">
                  <button
                    className="__adx_more "
                    onClick={() => addExpenseInput()}
                    disabled={isEditDetails?.isEdit ? true : false}
                  >
                    + Add More
                  </button>

                  <div className="__sideTl_detail" style={{ maxWidth: 'fit-content', minWidth: '155px' }}>
                    <div className="_alInvoiceSumry">
                      {(form?.is_gst && form?.vendor_id?.value && form?.place_of_supply?.label) ?
                        <>
                          <div className="_invsSum_fx">
                            <p className="_blackText"> Sub Total </p>
                            <p className="_blackText">{`₹ ${calculateTotalAmount()}`}</p>
                          </div>

                          {
                            (form?.place_of_supply?.label === isSupply?.gst_state?.label || form?.place_of_supply?.value === isSupply?.gst_state?.value) ? (
                              gstTypeAmount?.map((el) => {
                                return (
                                  <>
                                    <div className="_invsSum_fx">
                                      <p className="_blackText"> CGST {el?.tax / 2}% </p>
                                      <p className="_blackText">{`₹ ${(el?.gst).toFixed(2)}`}</p>
                                    </div>

                                    <div className="_invsSum_fx">
                                      <p className="_blackText"> SGST {el?.tax / 2}% </p>
                                      <p className="_blackText">{`₹ ${(el?.gst).toFixed(2)}`}</p>
                                    </div>
                                  </>
                                )
                              })
                            ) : (
                              gstTypeAmount?.map((el) => {
                                return (
                                  <>
                                    <div className="_invsSum_fx">
                                      <p className="_blackText"> IGST {el?.tax}% </p>
                                      <p className="_blackText">{`₹ ${(el?.gst * 2).toFixed(2)}`}</p>
                                    </div>
                                  </>
                                )
                              })
                            )
                          }

                          <div className="_invsSum_fx">
                            <p className="_blackText" style={{ marginRight: '5px' }}> Total </p>
                            <p className="_blackText">{form?.tax_type === 2 ? `₹ ${(+calculateTotalAmount() + +sumAmount()).toFixed(2)}` : `₹ ${(+calculateTotalAmount() - +sumAmount()).toFixed(2)}`}</p>
                          </div>
                        </> :
                        <div className="_invsSum_fx">
                          <p className="_blackText" style={{ marginRight: '5px' }}> Total </p>
                          <p className="_blackText">{`₹ ${calculateTotalAmount()}`}</p>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>

              <div className="px-3 w-100">
                <div className="_pMode_exbx">
                  <p>Payment Mode</p>
                  <div className="pFlex_bd">
                    {(form?.vendor_id?.value ? expenseTypeList : expenseTypeList.filter((el) => el?.value != 15)).map((i) => {
                      return (
                        <button
                          className={`_baseSpan ${i?.value == form?.account_sub_category
                            ? "active"
                            : "_bspDisable"
                            }`}
                          name="account_sub_category"
                          disabled={accountLoading || isEditDetails?.isEdit}
                          value={i.value}
                          onClick={({ target: { name, value } }) => {
                            setAccountType(value);
                            handleOnChange(name, Number(value));
                          }}

                        >
                          {i.label}
                        </button>
                      );
                    })}
                  </div>
                  {form?.account_sub_category != 15 && (
                    <div className="mt-4">
                      <CustomSelect
                        label="Select Account"
                        options={accountList}
                        placeholder="Select Account"
                        name="account_id"
                        onSelect={(data) => {
                          handleOnChange("account_id", data?.value);
                        }}
                        error={formError["account_id"]}
                        value={
                          form?.account_id
                            ? accountList?.find(
                              (i) => i.value == form?.account_id
                            )
                            : { label: "", value: "" }
                        }
                        errorShow={true}
                        disabled={isEditDetails?.isEdit}
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className="singleDiv _pMode_exbx px-3">
                <div className="_attatchmentBxs">
                  <p>Attachment</p>

                  <div className="__addExp_fileBx">
                    <input
                      type="file"
                      name=""
                      id="attachExp_file"
                      onChange={(e) => handleFileChange(e)}
                      disabled={loading || form?.file?.length >= 5 || isEditDetails?.isEdit}
                    />
                    <label htmlFor="attachExp_file">
                      {loading ? "Uploadding" : "+ Attach File"}
                    </label>
                    {formError?.file && (
                      <span className="input_drop_error">{formError?.file}</span>
                    )}
                  </div>
                  <div className="img_fnex_src">
                    {form?.file?.length > 0 &&
                      form?.file?.map((el, index) => {
                        return (
                          <>
                            <div className="pos-relative">
                              <img
                                className="_pdfIcon_sigxe"
                                src={`${masterData?.s3_url}${el?.path}`}
                                alt=""
                              />
                              {!isEditDetails?.isEdit ? <span className="_clDel_icon">
                                <IoCloseCircle
                                  onClick={() => documentRemove(index)}
                                />
                              </span> : <></>}
                            </div>
                          </>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CommonCanvas>
      {/* </CommonModal > */}
      {addNewExpense && <AddExpenseCategoryModal {...generalExpenseCategoryModal} />}

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${isOpenVenderModal ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: isOpenVenderModal ? 'visible' : 'hidden', zIndex: '1046' }}
      >
        {isOpenVenderModal &&
          <AddEditVendors
            isOpen={isOpenVenderModal}
            onClose={(e) => setIsOpenVenderModal(false)}
            setVenderSelection={(e) => setVenderSelection(e)}
            hideAddNewOption={false}
            branchFirmId={form?.branch_id?.firm_id}
          />
        }
      </div>
      <div style={{ zIndex: '1045' }} className={isOpenVenderModal ? 'offBack_drop' : ''}></div>
    </>
  );
};

export default AddExpensesModal;
